var paramerterToAttribute = {
    utmSource: 'utm_source',
    utmMedium: 'utm_medium',
    utmCampaign: 'utm_campaign',
    fingerprintId: 'fingerprint_id',
    ga4PseudoId: 'google_analytics_id',
};
export function getAttributtionFromStore(hostDetails) {
    if ((hostDetails === null || hostDetails === void 0 ? void 0 : hostDetails.config) &&
        'src' in hostDetails.config &&
        typeof hostDetails.config.src === 'string') {
        var attribution_1 = {};
        try {
            var url = new URL(hostDetails.config.src);
            var searchParams = new URLSearchParams(url.search);
            searchParams.forEach(function (value, key) {
                if (!(key in paramerterToAttribute))
                    return;
                attribution_1[paramerterToAttribute[key]] = value;
            });
        }
        catch (error) {
            console.error(error);
        }
        return attribution_1;
    }
}
